import { render, staticRenderFns } from "./damagesConfirmed.pug?vue&type=template&id=39096ee4&lang=pug&external"
import script from "./damagesConfirmed.js?vue&type=script&lang=js&external"
export * from "./damagesConfirmed.js?vue&type=script&lang=js&external"
import style0 from "./damagesConfirmed.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39096ee4')) {
      api.createRecord('39096ee4', component.options)
    } else {
      api.reload('39096ee4', component.options)
    }
    module.hot.accept("./damagesConfirmed.pug?vue&type=template&id=39096ee4&lang=pug&external", function () {
      api.rerender('39096ee4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/damagesConfirmed/index.vue"
export default component.exports